export const environment = {
  production: true,
  baseURL: 'api/rest/s1',
  baseWebSocketURL: 'api/notws'
};
